const steps = [
  {
    num: "1",
    title: "Gününü Seç",
    desc: "Teslim almak istediğin uygun günü seç.",
    icon: "ri-calendar-2-line",
  },
  {
    num: "2",
    title: "Menünü Oluştur",
    desc: "Sevdiğin yemeklerden kendi öğününü oluştur.",
    icon: "ri-list-check-3",
  },
  {
    num: "3",
    title: "Kapında Teslim Al",
    desc: "Siparişin günlük hazırlanır ve planlanan teslimat aralığında adresine ulaştırılır.",
    icon: "ri-home-heart-line",
  },
];

export default function HowItWorks() {
  return (
    <section id="nasil-calisir" className="bg-background-100 py-16 md:py-24 scroll-mt-20">
      <div className="mx-auto max-w-7xl px-4 md:px-6">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-xs font-bold tracking-[0.25em] text-primary-600 uppercase">
            Nasıl Çalışır?
          </span>
          <h2 className="mt-4 font-heading text-3xl md:text-5xl font-bold text-foreground-950 leading-tight">
            3 ADIMDA SOFRAN HAZIR.
          </h2>
        </div>

        <div className="mt-12 grid grid-cols-1 md:grid-cols-3 gap-6 relative">
          {/* connector line (desktop) */}
          <div className="hidden md:block absolute top-14 left-[16%] right-[16%] h-0.5 bg-background-300"></div>

          {steps.map((step) => (
            <div key={step.num} className="relative text-center px-6">
              <div className="relative z-10 w-28 h-28 mx-auto rounded-full bg-background-50 border border-background-200 flex items-center justify-center">
                <div className="w-16 h-16 rounded-full bg-primary-100 text-primary-700 flex items-center justify-center">
                  <i className={`${step.icon} text-3xl`}></i>
                </div>
                <span className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-accent-500 text-background-50 dark:text-foreground-950 flex items-center justify-center font-heading text-sm font-bold">
                  {step.num}
                </span>
              </div>
              <h3 className="mt-5 font-heading text-2xl font-bold text-foreground-950">
                {step.title}
              </h3>
              <p className="mt-2 text-sm text-foreground-600 leading-relaxed">{step.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}